import { FC } from "react";
import { Datagrid, List, ReferenceField, TextField } from "react-admin";

import CustomPagination from "../../components/CustomPagination";
import EmptyDataText from "../../components/EmptyDataText";
import TimestampField from "../../components/TimestampField";
import { AppResource } from "../../types/resource.types";
import SportMateType from "./components/SportMateType";

const SportMateEvents: FC<any> = (props) => {
  return (
    <List
      {...props}
      sort={{ field: "createdAt", order: "desc" }}
      pagination={<CustomPagination />}
      bulkActionButtons={false}
      filters={undefined}
      exporter={false}
    >
      <Datagrid empty={<EmptyDataText message="No events yet!" />}>
        <ReferenceField reference={AppResource.clients} source="clientId" label="Client" sortable={false} link={false}>
          <TextField source="displayName" />
        </ReferenceField>
        <TextField source="title" label="Title" sortable={false} />
        <SportMateType label="Type" sortable={false} />
        <TextField source="status" label="Status" sortable={false} />
        <TimestampField source="startDate" label="Start date" sortable={false} />
        <TimestampField source="endDate" label="End date" sortable={false} />
        <TimestampField source="createdAt" label="Created At" />
      </Datagrid>
    </List>
  );
};

export default SportMateEvents;
